import React, { forwardRef, InputHTMLAttributes } from 'react';
import useAppContext from 'flow/hooks/useAppContext';
import EmbeddedType from 'flow/types/embedded-type';
import BaseInput from './BaseInput';

interface Props extends InputHTMLAttributes<HTMLInputElement> {
    label?: string;
    defaultValue?: string;
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    ariaLabel?: string;
}

const TimeInput = forwardRef<HTMLInputElement, Props>(
    ({ label = null, defaultValue, onChange, ariaLabel }, ref) => {
        const { embedded } = useAppContext();

        return (
            <BaseInput
                label={label}
                type="time"
                defaultValue={defaultValue}
                ref={ref}
                onChange={onChange}
                {...(embedded === EmbeddedType.IOS && {
                    role: 'textbox',
                })}
                {...(ariaLabel && { 'aria-label': ariaLabel })}
            />
        );
    },
);

export default TimeInput;
